import workspaceQuery from '../../../graphql/queries/product/PhysicalDimensionDescriptionWorkspaceQuery.graphql';
import listQuery from '../../../graphql/queries/product/PhysicalDimensionDescriptionListQuery.graphql';
import instanceQuery from '../../../graphql/queries/product/PhysicalDimensionDescriptionQuery.graphql';
import defaultQuery from '../../../graphql/queries/product/PhysicalDimensionDescriptionDefault.graphql';
import mutationQuery from '../../../graphql/mutations/product/PhysicalDimensionDescriptionMutation.graphql';
import fragment from '../../../graphql/fragments/product/PhysicalDimensionDescriptionFragment.graphql';
import { Direction } from '../../schema/p4types';

const PhysicalDimensionDescription = {
  type: 'PhysicalDimensionDescription',
  title: 'Packaging Descriptions',
  formTitle: 'Packaging Description',
  formUrl: '/Products/PhysicalDimensionDescription/Details/',
  workspaceUrl: '/Products/PhysicalDimensionDescription/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  dropdown: {
    query: listQuery,
    valueKey: 'id',
    labelKey: 'description',
    customVariables: () => {
      return {
        orderBy: 'description',
        orderDirection: Direction.Asc,
      };
    },
  },
  fragment,
  screenReference: 'PHYSICAL_DIMENSION_DESCRIPTION',
};

export default PhysicalDimensionDescription;
